{
  "name": "ir-dashboard",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:uat": "ng serve --configuration uat",
    "build": "ng build",
    "build:local": "ng build --configuration development",
    "build:uat": "ng build --configuration uat",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint --fix"
  },
  "private": true,
  "packageManager": "npm@11.18.0",
  "dependencies": {
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@azure/msal-browser": "^5.24.0",
    "@ng-icons/bootstrap-icons": "^36.1.0",
    "@ng-icons/core": "^36.1.0",
    "@openng/optimus-ui": "^2.0.2",
    "@openng/optimus-ui-themes": "^2.0.2",
    "echarts": "^6.1.0",
    "ngx-echarts": "^22.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@eslint/js": "^10.0.1",
    "@openng/optimus-ui-tailwindcss": "^2.0.2",
    "@tailwindcss/postcss": "^4.3.3",
    "@tailwindcss/typography": "^0.5.20",
    "@vitest/coverage-v8": "^5.0.3",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.12.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "jsdom": "^30.1.2",
    "postcss": "^8.5.29",
    "prettier": "^3.9.9",
    "tailwindcss": "^4.3.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.1",
    "vitest": "^5.0.3"
  },
  "allowScripts": {
    "@parcel/watcher@2.6.0": true,
    "esbuild@0.28.2": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true
  }
}
